const MAX_WIDTH_DEFAULT = 512;

export async function resizeImage(file: File, maxWidth = MAX_WIDTH_DEFAULT): Promise<Blob> {
  if (!file.type.startsWith("image/")) {
    throw new Error("Not an image file");
  }

  if (typeof createImageBitmap !== "function") {
    return file;
  }

  const bitmap = await createImageBitmap(file).catch(() => null);
  if (!bitmap) {
    return file;
  }

  if (bitmap.width <= maxWidth) {
    bitmap.close();
    return file;
  }

  const scale = maxWidth / bitmap.width;
  const targetWidth = maxWidth;
  const targetHeight = Math.round(bitmap.height * scale);

  const canvas = document.createElement("canvas");
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    bitmap.close();
    throw new Error("Canvas context unavailable");
  }
  ctx.drawImage(bitmap, 0, 0, targetWidth, targetHeight);
  bitmap.close();

  return await new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("toBlob failed"))),
      file.type,
    );
  });
}
